import { useEffect } from "react"
import { logger } from "../lib/logger"
import { useRouterStore } from "../stores/StoreContext"
import { routes } from "./routes"

export const GitHubCallbackPage = () => {
  const router = useRouterStore()

  useEffect(() => {
    // In a real app, you would exchange the code for a token here
    const urlParams = new URLSearchParams(window.location.search)
    const code = urlParams.get("code")

    if (code) {
      // TODO: Exchange code for token with your backend
      logger.debug("GitHub OAuth code received", {
        component: "GitHubCallback",
        hasCode: true,
      })

      // Track analytics event
      logger.track("github_oauth_callback_received")

      // For now, just redirect to home
      setTimeout(() => {
        router.goTo(routes.home)
      }, 2000)
    } else {
      router.goTo(routes.home)
    }
  }, [router])

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-white mx-auto mb-4" />
        <p className="text-lg">Completing GitHub authentication...</p>
      </div>
    </div>
  )
}
